<template>
  <div>
    <CourseVideoPlaceholderBoard>
      <template #title>
        <span class="d-none d-sm-block">Aula disponível gratuitamente!</span>
      </template>

      <template #subtitle class="mt-0">
        Crie sua conta de forma <u>grátis</u> e assista na íntegra aulas exclusivas para membros CyberClass!
      </template>
    </CourseVideoPlaceholderBoard>

    <div class="text-center mt-sm-5 mt-4">
      <LandingButton class="button button--primary button--size-md" @click="openAuthModal">CRIAR CONTA GRÁTIS</LandingButton>
    </div>
  </div>
</template>

<script>
import CourseVideoPlaceholderBoard from '@/components/course/video-placeholder/CourseVideoPlaceholderBoard'
import LandingButton from '@/components/buttons/LandingButton.vue'
import AuthFormModal from '@/components/modals/auth/AuthFormModal'

export default {
  components: {
    CourseVideoPlaceholderBoard,
    LandingButton,
  },

  methods: {
    openAuthModal () {
      this.$modal.show(AuthFormModal, {
        defaultTab: 'sign-up'
      }, { width: '343px' }, {
        'closed': () => this.$store.commit('auth/resetModal')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .button {
    font-size: 14px;
  }
</style>